import styled from "@emotion/styled";
import { Box } from "@mui/material";
import React, { FC, ReactNode } from "react";

// Styled components
const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const TimelineItemContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledDot = styled.div`
  width: 24px;
  height: 24px;
  background-color: #7d7d7d;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 999px;
  border: 4px solid #7d7d7d66;
  -webkit-background-clip: padding-box; /* for Safari */
  background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */
  margin: 8px 0;
`;

const StyledConnector = styled.div`
  flex: 1;
  background-color: #7d7d7d;
  opacity: 0.3;
  width: 1px;
  min-height: 55px;
`;

const StyledContentContainer = styled.div``;

// Types
interface TimelineItemProps {
  children: ReactNode;
}

interface TimelineContentProps {
  children: ReactNode;
}

// Components
const TimelineItem: FC<TimelineItemProps> = ({ children }) => {
  const { dotNode, connectorNode, contentNode } = React.Children.toArray(children).reduce(
    (obj, currEle) => {
      if (React.isValidElement(currEle)) {
        if (currEle.type === TimelineDot) {
          obj.dotNode = currEle;
        } else if (currEle.type === TimelineConnector) {
          obj.connectorNode = currEle;
        } else if (currEle.type === TimelineContent) {
          obj.contentNode = currEle;
        }
      }

      return obj;
    },
    {
      dotNode: null,
      connectorNode: null,
      contentNode: null,
    }
  );

  return (
    <TimelineItemContainer>
      <Box flexDirection="column" display="flex" alignItems="center" mr="16px">
        {dotNode}
        {connectorNode}
      </Box>
      <Box>{contentNode}</Box>
    </TimelineItemContainer>
  );
};

const TimelineDot: FC = () => {
  return <StyledDot />;
};

const TimelineContent: FC<TimelineContentProps> = ({ children }) => {
  return <StyledContentContainer>{children}</StyledContentContainer>;
};

const TimelineConnector: FC = () => {
  return <StyledConnector />;
};

const Timeline: FC<{ children: ReactNode }> = ({ children }) => {
  return <TimelineContainer>{children}</TimelineContainer>;
};

export { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem };

export default Timeline;
